import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContext } from '@hero/web-context';
import ApplicationsCards from '@/components/features/Applications/ApplicationsCards';

export default function SettingsPage() {
  const { t } = useTranslation(['dashboard']);
  const { setPageName } = usePageContext();

  useEffect(() => {
    setPageName(t('dashboard:Settings.title'));
  }, [setPageName, t]);

  return <ApplicationsCards />;
}
